import { Component, ElementRef, OnInit, ViewContainerRef, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { Cooperative } from '../../../models/cooperatives';
import { Promotion } from '../../../models/promotion';
import { Options } from '../../../models/options';
import { environment } from '../../../../environments/environment';
import { Product, Duration, Source } from '../../../models/product';
import { Onboarding, OnbValidators, Status, PaymentType } from '../../../models/onboarding';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import { AlgPromoDetailsModalComponent } from '../../dialogs/alg-promo-details/alg-promo-details.component';

import { ModalDialogService } from 'ngx-modal-dialog';
import { LinkInfo } from '../../../models/link_info';
import { FriendCode } from '../../../models/friend-code';
import { Observable } from 'rxjs/Observable';
import { UtilsService } from '../../../services/utils.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime, take } from 'rxjs/operators';
import { Output } from '@angular/core';

@Component({
  selector: 'alg-payment',
  templateUrl: './alg-payment.component.html',
  styleUrls: ['./alg-payment.component.scss'],
})
export class AlgPaymentComponent implements OnInit, OnDestroy {
  @Output() statusBack = new EventEmitter<string>();

  public cooperatives: Cooperative[];
  public promotions: Promotion[];
  public friends: FriendCode[];
  public options: Options;
  public imageUrl: string;
  public currentProduct: Product;
  public currentSource: string;
  public isAccendiUnicaCoop: boolean;
  public currentOnboarding: Onboarding = {} as Onboarding;
  public forceIndex: Number = -1;
  public codeCardError: Boolean = false;
  public currentCooperative: Number = -1;
  public currentCooperativeObject: Cooperative;
  public checkboxClass = false;
  public isValidSocioCode: boolean;
  public socioCode: string;
  public currentIndexDesktop = 1;
  public elementShowed = 3;
  public cardSelected: any;
  public cardSelectedIndex = -1;
  public showLeft = false;
  public showRight = true;
  public isCodeCardValid = false;
  public outcomeCoopMember;
  public extraPoints: string;
  public maxLength = 13;
  public promoCodeModel: string;

  public currentIndex = 0;
  public paymentForm: FormGroup = new FormGroup({});

  public currentPromo: any;

  public goToNextStep = false;

  public product: Product;
  public defaultPayment: string;
  public defaultCardSocio: string;

  public linkInfoLabel: string;
  public linkInfoDescription: string;

  public backCard: string;
  public isFriendsPromo: boolean;
  public isFriendsPromoSalesforce: boolean;
  public isShowAddPromotionalCode: boolean = true;
  public hasCorrectValue = false;
  public isSocioValid = true;
  public isPromoValid = false;
  public promoValidMessage: string;
  public paymentValid = true;
  public noInitialValue = false;
  public inputFocus = false;
  public isInitialCodePresent = false;
  public promoCodePlaceholder = 'PROMO';
  public socioOptions = [
    {
      label: 'Si, sono socio',
      value: true,
    },
    {
      label: 'No, non sono socio',
      value: false,
    },
  ];
  public ibanOptions = [
    {
      label: 'Si',
      value: 'No',
    },
    {
      label: 'No',
      value: 'Yes',
    },
  ];
  public clauseLibretto = [
    {
      label: 'Accetto e prendo visione delle clausole sulla cessione del credito per il pagamento tramite Libretto Socio Prestatore.',
      value: true,
    },
  ];

  private socioForm = {
    isSocio: new FormControl(this.currentOnboarding.isSocio, {}),
    codeCard: new FormControl(this.currentOnboarding.codeCard, {}),
  };

  private paymentFields = {
    Libretto: {
      librettoValidation: new FormControl(this.currentOnboarding.librettoValidation, {
        validators: [Validators.requiredTrue, Validators.minLength(18), Validators.maxLength(18)],
      }),
      librettoCode: new FormControl(this.currentOnboarding.librettoCode, {
        validators: [Validators.required, Validators.minLength(13), Validators.maxLength(13)],
      }),
    },
    Rid: {
      iban: new FormControl(this.currentOnboarding.iban, {
        validators: [Validators.required, OnbValidators.iban],
      }),
      differentIbanAccountholder: new FormControl(this.currentOnboarding.differentIbanAccountholder, {
        validators: [Validators.required],
      }),
    },
  };
  private ibanFields = {
    sottoscrittoreFullname: new FormControl(this.currentOnboarding.sottoscrittoreFullname, {
      validators: [Validators.required],
    }),
    sottoscrittoreCF: new FormControl(this.currentOnboarding.sottoscrittoreCF, {
      validators: [Validators.required, OnbValidators.cf],
    }),
  };
  private promoFormControl: FormControl;
  private friendFormControl: FormControl;
  public promo_error_message = 'PROMO_INVALID'; // PROMO_DURATION_INVALID
  public isPromoBoxOpen = false;
  public promoDetails = false;
  public showRidInfos = false;
  public greenEnergyEnabledWithPromo: boolean;
  public isProductPlacet: boolean;
  public isLibrettoControlled: boolean;
  public librettoInputDisabled: boolean;
  public isLibrettoValid: boolean;
  public resetLibrettoValidations: boolean;
  public paymentLists: any[] = [];

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private gtm: AlgGtmService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    const observer = this.api.cooperatives.subscribe((cooperatives: Cooperative[]) => {
      this.cooperatives = cooperatives;
    });
    this.api.isLibrettoValid$.subscribe((item) => {
      this.isLibrettoValid = item;
    });
    this.api.isLibrettoInputDisabled$.subscribe((item) => {
      this.librettoInputDisabled = item;
    });
    this.api.isLibrettoCodeConfirmed$.subscribe((item) => {
      this.resetLibrettoValidations = item;
    });
    this.api.promotions.subscribe((promotions: Promotion[]) => {
      this.promotions = promotions;
    });
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct, this.api.promotions, this.api.options)
      .subscribe(([onboarding, product, promotions, options]) => {
        this.promoFormControl = new FormControl(this.promoCodeModel, {
          asyncValidators: [
            (control: AbstractControl) => {
              return this.checkPromoDetails()
                .then((res) => {
                  if (res) {
                    control.setErrors(null);
                    return null;
                  }
                  return { promo: true };
                })
                .catch((err) => {
                  return { promo: true };
                });
            },
          ],
          updateOn: 'blur',
        });
        this.paymentForm = null;
        this.genFormControl(product, onboarding);
        this.setSocioSection(onboarding);

        this.currentOnboarding = onboarding;
        this.currentOnboarding.differentIbanAccountholder = onboarding.differentIbanAccountholder === 'Yes' || onboarding.differentIbanAccountholder === true;

        this.currentOnboarding.isPromoSelected = !(!onboarding.isPromoSelected || onboarding.isPromoSelected.toString() === 'false');
        this.currentOnboarding.isFriendSelected = !(!onboarding.isFriendSelected || onboarding.isFriendSelected.toString() === 'false');

        if (this.currentOnboarding.differentIbanAccountholder === true || this.currentOnboarding.differentIbanAccountholder === 'Yes') {
          this.setIbanFields(this.currentOnboarding);
        }

        if (this.currentOnboarding.socioType) {
          this.defaultCardSocio = this.currentOnboarding.socioType;
        }
        this.currentProduct = product;

        const paymentOptList = this._allowedPayment();
        this.paymentLists = paymentOptList.map((n) => ({
          label: n === 'Rid' ? 'Domiciliazione bancaria' : n,
          value: `${n}`,
        }));
        if (this.paymentLists.length === 1 && this.paymentLists[0].value.toLowerCase() === 'rid' && !this.currentOnboarding.paymentType) {
          this.showRidInfos = true;
          this.currentOnboarding.paymentType = PaymentType.rid;
        } else if (this.paymentLists.length > 1) {
          this.showRidInfos = false;
        }

        if (this.currentOnboarding.socioType) {
          this.cooperatives.map((v, i) => {
            if (v._id === this.currentOnboarding.socioType) {
              this.onChangeCard(i, this.currentOnboarding.paymentType || null);
            }
          });
        }

        if (this.currentOnboarding.paymentType === PaymentType.bollettino || this.currentOnboarding.paymentType === PaymentType.libretto) {
          this.paymentForm.removeControl('sottoscrittoreCF');
          this.paymentForm.removeControl('sottoscrittoreFullname');
        }
        this.initPromoValue(options);
        this.setPaymentFields(this.currentOnboarding);
        if (this.currentOnboarding.paymentType === PaymentType.libretto && this.currentOnboarding.librettoCode) {
          this.api.isLibrettoInputDisabled$.next(true);
          this.api.isLibrettoValid$.next(true);
        }
      });
    this.paymentForm.valueChanges.subscribe(this.onFormChanges);
    this.paymentForm.statusChanges.subscribe((status) => {
      this.allowNextStep();
    });
    if (this.currentOnboarding.codeCard !== null) {
      this.noInitialValue = false;
    }
    if (this.currentOnboarding.codeCard === '') {
      this.noInitialValue = true;
    }
    this.imageUrl = environment.imageUrl;
    if (this.currentOnboarding.paymentType) {
      return (this.hasCorrectValue = true);
    }
  }

  private initPromoValue(options: Options) {
    this.options = options;
    this.isFriendsPromoSalesforce = this.options.friendsPromoSalesforce;
    this.isFriendsPromo = this.options.localCodesPromo;
    if (this.currentProduct.family) {
      this.currentSource = this.currentProduct.family.productSource;
      if (this.currentSource == Source.accendiUnicaCoop) {
        this.isAccendiUnicaCoop = true;
      }
      this.isShowAddPromotionalCode = this.currentProduct.family.promotionAllowed;
    }
    if (this.currentOnboarding.promoCode) {
      if (this.currentOnboarding.isPromoSelected) {
        this.promoCodeModel = this.currentOnboarding.promoCode;
      } else if (this.currentOnboarding.isFriendSelected) {
        this.promoCodeModel = this.currentOnboarding.friendCode;
      }
      this.isPromoBoxOpen = true;
      this.currentOnboarding.isPromoSelected = true;
      setTimeout(() => {
        if (<HTMLInputElement>document.getElementById('input-promoCode')) {
          (<HTMLInputElement>document.getElementById('input-promoCode')).value = this.promoCodeModel;
        }
      }, 150);
    }
  }

  ngOnDestroy() {
    if (!this.resetLibrettoValidations || !this.goToNextStep) {
      this.api.isLibrettoInputDisabled$.next(false);
      this.api.isLibrettoValid$.next(undefined);
    }
  }

  // tslint:disable-next-line: member-ordering
  public selectionTypeOfPayment = new FormGroup({
    paymentSupplier: new FormControl(this.currentOnboarding.paymentType, {
      validators: [Validators.required],
    }),
  });

  private genFormControl(product: Product, onboarding: Onboarding) {
    this.product = product;
    let fields = {};
    if (product.family && product.family.partnershipAllowed) {
      fields = { ...fields, ...this.socioForm };
    }
    if (product.family && product.family.promotionAllowed) {
      fields = { ...fields };
    }
    if (onboarding.isPromoSelected === true) {
      fields = { ...fields, promoCode: this.promoFormControl };
    }
    this.paymentForm = new FormGroup({ ...fields });

    this.paymentForm.valueChanges.subscribe(this.onFormChanges);
    this.paymentForm.statusChanges.subscribe(() => {
      setTimeout(() => {
        if (this.currentOnboarding.isSocio && this.currentOnboarding.paymentType === PaymentType.libretto) {
          this.paymentForm.controls['librettoCode'].valueChanges.subscribe(() => {
            if (this.paymentForm.get('librettoCode').valid) {
              this.isLibrettoControlled = true;
            } else {
              this.isLibrettoControlled = false;
              this.api.isLibrettoInputDisabled$.next(false);
              this.api.isLibrettoValid$.next(undefined);
            }
          });
        }
      }, 100);
      this.allowNextStep();
    });
  }

  openModal() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: LinkInfo(this.linkInfoLabel).title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: this.linkInfoDescription,
      },
    });
  }

  openModalPromoDetails() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Promo ${this.currentPromo.code}`,
      childComponent: AlgPromoDetailsModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: this.currentPromo.promoDescriptionModal,
        buttonText: 'Torna alla compilazione',
      },
    });
  }

  openModalCodiceSocio() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Codice socio prestatore`,
      childComponent: AlgPromoDetailsModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: `L' intestatario del Libretto Socio Prestatore deve corrispondere all'intestatario della fornitura Accendi luce & gas.`,
        buttonText: 'Torna alla compilazione',
      },
    });
  }

  openLink(index) {
    if (index === 1) {
      this.linkInfoLabel = 'codice_tessera';
      this.linkInfoDescription = `<img src='${this.imageUrl}${this.backCard}' alt='card' title='card' />`;
    } else {
      this.linkInfoLabel = 'clause';
      this.linkInfoDescription = LinkInfo('clause').description;
    }
    this.openModal();
  }

  onChangeCard(index, paymentType = null) {
    this.currentCooperative = index;
    this.currentCooperativeObject = this.cooperatives[index];
    this.forceIndex = index;
    this.backCard = this.cooperatives[index].backCard.filename;
    this.currentOnboarding.socioType = this.defaultCardSocio = this.cooperatives[index]._id;
    if (this.currentCooperative === 0) {
      this.maxLength = 8;
    } else {
      this.maxLength = 13;
    }

    // if (this.currentProduct.duration === Duration.m24) {
    //   this.extraPoints = this.cooperatives[index].pointsFor24;
    // } else {
    //   this.extraPoints = this.cooperatives[index].pointsFor12;
    // }
    this.extraPoints = this.cooperatives[index].pointsFor12;
    this.paymentForm.controls.codeCard.setValidators([
      Validators.required,
      Validators.maxLength(this.cooperatives[index].codeMaxLenght),
      Validators.minLength(this.cooperatives[index].codeMaxLenght),
    ]);

    this.maxLength = this.cooperatives[index].codeMaxLenght;
    if (window.innerWidth < 768) {
      this.cardSelected = index;
    } else {
      this.currentIndex = index;
    }
    this.cardSelected = index;
    // this.currentOnboarding.codeCard = '';
    this.onFormChanges(this.currentOnboarding);

    const paymentOptList = this._allowedPayment();
    this.paymentLists = paymentOptList.map((n) => ({
      label: n === 'Rid' ? 'Domiciliazione bancaria' : n,
      value: `${n}`,
    }));
    if (this.paymentLists.length === 1 && this.paymentLists[0].value.toLowerCase() === 'rid' && !this.currentOnboarding.paymentType) {
      this.showRidInfos = true;
      this.currentOnboarding.paymentType = PaymentType.rid;
    } else if (this.paymentLists.length > 1 && !paymentType) {
      this.currentOnboarding.paymentType = undefined;
      this.hasCorrectValue = false;
      this.showRidInfos = false;
    }
  }

  private _allowedPayment() {
    const paymentOptList = [];
    if (this.currentProduct && !!this.currentProduct.family && !this.currentProduct.family.ridDisabled) {
      paymentOptList.push('Rid');
    }
    if (this.currentProduct && !!this.currentProduct.family && !this.currentProduct.family.bollettinoDisabled) {
      paymentOptList.push('Bollettino');
    }
    if (
      this.currentProduct &&
      !!this.currentProduct.family &&
      !this.currentProduct.family.librettoDisabled &&
      this.currentProduct.family.name !== 'Placet' &&
      ((this.currentCooperativeObject && this.currentCooperativeObject.librettoAllowed && this.currentOnboarding.socioType) ||
        (!!this.currentProduct.family && !this.currentProduct.family.librettoDisabled && this.currentSource === Source.accendiUnicaCoop))
    ) {
      paymentOptList.push('Libretto');
    }
    if (this.currentProduct && !!this.currentProduct.family && this.currentProduct.family.name === 'Placet') {
      this.isProductPlacet = true;
    }
    return paymentOptList;
  }
  onChangeCardNumber(codeCard) {
    const patt1 = new RegExp('^' + '(0240|0241|0244|0245|0260|0262|0250|0251|0252|0253|0265|0269)', 'i');

    if (codeCard.startsWith('0249')) {
      // COOP RENO
      this.onChangeCard(2);
    } else if (
      codeCard.startsWith('029') ||
      codeCard.startsWith('031') ||
      codeCard.startsWith('032') ||
      codeCard.startsWith('035') ||
      codeCard.startsWith('038')
    ) {
      // COOP TIRRENO
      this.onChangeCard(0);
    } else if (patt1.test(codeCard)) {
      this.onChangeCard(1);
    } else {
      this.forceIndex = -1;
    }
    this.noInitialValue = false;
  }

  private onFormChanges = (data) => {
    if (data.codeCard && data.isSocio === true) {
      this.codeCardError = false;
      if (this.paymentForm.controls.codeCard.valid) {
        this.isCodeCardValid = true;
        switch (this.currentIndex) {
          case 2:
            if (!data.codeCard.startsWith('0249')) {
              this.codeCardError = true;
              this.isCodeCardValid = false;
            }
            break;
          case 0:
            const patt = new RegExp('^' + '(029|031|032|035|038)', 'i');
            if (!patt.test(data.codeCard)) {
              this.codeCardError = true;
              this.isCodeCardValid = false;
            }
            break;
          case 1:
            const patt1 = new RegExp('^' + '(0240|0241|0244|0245|0260|0262|0250|0251|0252|0253|0265|0269)', 'i');
            if (!patt1.test(data.codeCard)) {
              this.codeCardError = true;
              this.isCodeCardValid = false;
            }
            break;
        }
      } else {
        this.isCodeCardValid = false;
        this.codeCardError = true;
      }
    } else {
      this.isCodeCardValid = false;
      this.codeCardError = false;
    }
  };

  hasInputValue(value) {
    if (value === '' || value === 0) {
      this.noInitialValue = true;
      this.isInitialCodePresent = false;
    }
  }

  inputFocusIn() {
    this.inputFocus = true;
    if (this.currentCooperative === 0) {
      this.maxLength = 8;
    } else {
      this.maxLength = 13;
    }
  }

  inputFocusOut(event) {
    this.inputFocus = false;
    if (this.currentCooperative === 0) {
      this.maxLength = 8;
    } else {
      this.maxLength = 13;
    }

    if (this.currentOnboarding.codeCard === null || event.target.value.length < this.maxLength || this.currentOnboarding.codeCard === '') {
      event.target.value = '';
      this.noInitialValue = true;
      this.isCodeCardValid = false;
      this.currentOnboarding.codeCard = '';
      this.isCodeCardValid = false;
    }
  }

  private allowNextStep() {
    this.goToNextStep =
      this.paymentForm.status === 'VALID' && [PaymentType.bollettino, PaymentType.rid, PaymentType.libretto].indexOf(this.currentOnboarding.paymentType) !== -1;
  }

  // payment type choose
  private setPaymentFields = (onboarding: Onboarding) => {
    Object.keys(this.paymentFields).forEach((paymentType) => {
      if (paymentType === onboarding.paymentType) {
        Object.keys(this.paymentFields[paymentType]).forEach((k) => {
          this.paymentForm.addControl(k, this.paymentFields[paymentType][k]);
        });
      } else {
        Object.keys(this.paymentFields[paymentType]).forEach((k) => {
          if (this.paymentForm.controls[k]) {
            this.paymentForm.removeControl(k);
          }
        });
      }
    });
  };
  //nuova condizione. se il type === Rid azzerrare libretto code
  changePayment(type) {
    if (type !== 'Rid') {
      this.currentOnboarding.iban = null;
      if (<HTMLInputElement>document.getElementById('input-iban')) {
        (<HTMLInputElement>document.getElementById('input-iban')).value = null;
        this.paymentForm.removeControl('sottoscrittoreCF');
        this.paymentForm.removeControl('sottoscrittoreFullname');
      }
    } else {
      setTimeout(() => {
        if (<HTMLInputElement>document.getElementById('input-iban')) {
          (<HTMLInputElement>document.getElementById('input-iban')).value = null;
        }
      }, 20);
      this.currentOnboarding.differentIbanAccountholder = false;
    }
    if (type === 'Rid' || type === 'Bollettino') {
      this.currentOnboarding.librettoCode = '';
      this.isLibrettoValid = undefined;
      this.api.isLibrettoInputDisabled$.next(false);
      this.api.isLibrettoValid$.next(undefined);
    }
    if (type === 'Libretto') {
      this.isLibrettoValid = undefined;
    }
    this.currentOnboarding.paymentType = type;
    this.defaultPayment = type;
    this.setPaymentFields(this.currentOnboarding);
    this.allowNextStep();
    this.currentOnboarding.socioType = this.defaultCardSocio;
  }

  // Value radio Socio (Yes/No)
  private setSocioSection(onboarding: Onboarding) {
    if (this.currentOnboarding.paymentType === PaymentType.libretto && this.paymentForm.controls.isSocio && this.paymentForm.controls.isSocio.valid) {
      this.currentOnboarding.paymentType = null;
      this.defaultPayment = '';
      this.currentOnboarding.librettoCode = '';
      this.currentOnboarding.librettoValidation = 'false';
      this.nextStep();
    }
    if (this.paymentForm.controls.codeCard) {
      this.paymentForm.removeControl('codeCard');
    }
    if (onboarding.isSocio) {
      this.paymentForm.addControl(
        'codeCard',
        new FormControl(this.currentOnboarding.codeCard, {
          validators: [Validators.required],
        })
      );
      this.noInitialValue = true;
    } else {
      this.paymentLists = this.paymentLists.filter((i) => i.value.toLowerCase() !== 'libretto');
      this.currentOnboarding.socioType = null;
      this.defaultCardSocio = null;
      this.paymentForm.removeControl('codeCard');
      this.currentOnboarding.codeCard = null;
      this.currentOnboarding.librettoCode = null;
      this.currentOnboarding.differentIbanAccountholder = false;
    }
  }

  changeValidationClass() {
    this.checkboxClass = !this.currentOnboarding.librettoValidation;
  }

  controlCheckbox() {
    if (!this.currentOnboarding.librettoValidation) {
      return (this.checkboxClass = true);
    }
  }

  gtmPush(data) {
    this.setSocioSection(this.currentOnboarding);
    this.gtm.submitOnbEvent('Scelta Sei socio Coop?', data ? 'true' : 'false');
  }

  // IBAN different accountholder (Yes/No)
  private setIbanFields = (onboarding: Onboarding) => {
    if (onboarding.differentIbanAccountholder === true) {
      Object.keys(this.ibanFields).forEach((k) => {
        this.paymentForm.addControl(k, this.ibanFields[k]);
      });
    } else {
      Object.keys(this.ibanFields).forEach((k) => {
        if (this.paymentForm.controls[k]) {
          this.paymentForm.removeControl(k);
        }
      });
    }
  };

  private setIbanSection(onboarding: Onboarding) {
    this.setIbanFields(onboarding);
  }

  changeIban(event) {
    this.setIbanSection(this.currentOnboarding);
    if (event === false) {
      this.currentOnboarding.sottoscrittoreFullname = '';
      delete this.currentOnboarding.sottoscrittoreCF;

      this.currentOnboarding.sottoscrittoreCF = '';
      delete this.currentOnboarding.sottoscrittoreFullname;
    }
  }

  enableGreenOnPromo() {
    if (this.product.type !== 'Gas') {
      for (let i = 0; i < this.promotions.length; i++) {
        if (this.promotions[i].enableGreenPromo) {
          if (this.currentOnboarding.promoCode === this.promotions[i].code) {
            this.api.currentLightGreen.next(true);
            this.api.updateGreenEnergyPromo.next(true);
            this.greenEnergyEnabledWithPromo = !this.greenEnergyEnabledWithPromo;
          } else {
            this.disableGreenPromo();
          }
        }
      }
    }
  }

  disableGreenPromo() {
    this.api.currentLightGreen.next(false);
    this.api.updateGreenEnergyPromo.next(false);
  }
  getSocioCode(value) {
    this.currentOnboarding.codeCard = value;
    console.log('socio-code', this.currentOnboarding.codeCard);
  }
  getOutcomeCoopMember(value) {
    console.log({ value });
    this.outcomeCoopMember = value;
  }

  checkIsCoopMemberRegistry(value) {
    this.isValidSocioCode = value;
    console.log('ismember', this.isValidSocioCode);
    if (this.isValidSocioCode) {
      this.currentOnboarding.cardValidationOutcome = this.outcomeCoopMember.cardValidationOutcome;
      this.currentOnboarding.cardValidationDescription = this.outcomeCoopMember.cardValidationDescription;
      this.currentOnboarding.contractsMemberOutcome = this.outcomeCoopMember.contractsMemberOutcome;
    }
  }

  public nextStep() {
    console.log('onboarding', this.currentOnboarding);

    this.markFormGroupTouched(this.paymentForm);

    const invalidControl = this.el.nativeElement.querySelector('form .ng-invalid');
    if (invalidControl) {
      return this.scrollOnInvalidElement(invalidControl);
    }

    if (!!this.paymentForm.controls.isSocio) {
      this.isSocioValid = this.paymentForm.controls.isSocio.valid;
    }

    if (!this.defaultPayment) {
      this.paymentValid = false;
    }
    if (!this.resetLibrettoValidations && this.currentOnboarding.paymentType === 'Libretto' && !this.isLibrettoValid) {
      return;
    }
    if (this.paymentForm.status === 'VALID' && this.currentOnboarding.paymentType) {
      if (!this.currentOnboarding.sottoscrittoreCF) {
        delete this.currentOnboarding.sottoscrittoreCF;
      }
      if (!this.currentOnboarding.sottoscrittoreFullname) {
        delete this.currentOnboarding.sottoscrittoreFullname;
      }
      if (this.currentOnboarding.isFriendSelected === true) {
        this.currentOnboarding.promoCode = 'AMICO';
      }
      if (!this.openPromoBox) {
        this.paymentForm.removeControl('promoCode');
        this.paymentForm.removeControl('friendCode');
        this.currentOnboarding.friendCode = null;
        this.currentOnboarding.promoCode = null;
        this.currentOnboarding.isPromoSelected = false;
        this.currentOnboarding.isFriendSelected = false;
        this.disableGreenPromo();
      }
      if (this.currentOnboarding.paymentType !== 'Rid') {
        this.currentOnboarding.iban = '';
        this.currentOnboarding.differentIbanAccountholder = 'No';
      }
      this.currentOnboarding.differentIbanAccountholder = this.currentOnboarding.differentIbanAccountholder ? 'Yes' : 'No';
      this.statusBack.emit('current');
      if (this.isProductPlacet) {
        this.api.nextStep(this.currentOnboarding, Status.insurance);
      } else {
        this.api.nextStep(this.currentOnboarding, Status.payment);
      }
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private scrollOnInvalidElement(invalidControl) {
    this.controlCheckbox();
    window.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(window, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => invalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  public trackPromoCode() {
    setTimeout(() => {
      if (this.paymentForm.controls.promoCode && this.paymentForm.controls.promoCode.errors) {
        return this.gtm.submitOnbEvent('Codice promo', 'error');
      }
      if (this.paymentForm.controls.promoCode && this.paymentForm.controls.promoCode.valid) {
        this.enableGreenOnPromo();
        return this.gtm.submitOnbEvent('Codice promo', 'ok');
      }
    }, 100);
    this.allowNextStep();
  }
  async checkPromoDetails(): Promise<boolean> {
    if (!this.promoCodeModel) {
      this.promoValidMessage = '';
      return false;
    }

    if (this.currentProduct.family && this.currentProduct.family.promotionAllowed) {
      for (const promo of this.promotions) {
        if (promo.code.toLowerCase() === this.promoCodeModel.toLowerCase()) {
          this.currentPromo = promo;
          this.promoDetails = true;
          this.isPromoValid = true;
          this.currentOnboarding.promoCode = this.promoCodeModel;
          this.currentOnboarding.isPromoSelected = true;
          this.promoValidMessage = this.getPromoDescription(promo) || this.options.promoSuccessMessage;
          this.trackPromoCode();
          return true;
        }
      }
    }

    if (this.isFriendsPromo) {
      const valid = await this.api.checkFriend(this.promoCodeModel);
      if (valid && valid.found) {
        this.isPromoValid = true;
        this.currentOnboarding.isFriendSelected = true;
        this.currentOnboarding.promoCode = 'AMICO';
        this.currentOnboarding.friendCode = this.promoCodeModel;
        this.promoValidMessage = this.options.localCodesPromoSuccessMessage;
        this.trackPromoCode();
        return true;
      }
    }

    if (this.isFriendsPromoSalesforce) {
      try {
        const { status, message } = await this.api.checkFriendLiveFromSF(this.promoCodeModel, this.currentOnboarding._id);
        if (status) {
          this.isPromoValid = true;
          this.currentOnboarding.promoCode = 'AMICO';
          this.currentOnboarding.friendCode = this.promoCodeModel;
          this.currentOnboarding.isFriendSelected = true;
          this.promoValidMessage = this.options.friendsPromoSalesforceSuccessMessage;
          this.trackPromoCode();
          return true;
        }
      } catch (error) {
        console.log('error', error);
      }
    }

    this.isPromoValid = false;
    this.promoValidMessage = '';
    this.currentOnboarding.isFriendSelected = false;
    this.currentOnboarding.promoCode = null;
    this.currentOnboarding.isPromoSelected = false;
    this.currentOnboarding.friendCode = null;
    this.trackPromoCode();
    return false;
  }

  onPromoCodeChange(value) {
    this.promoCodeModel = value;
    if (this.promoCodeModel === '' || this.promoCodeModel === null || this.promoCodeModel === undefined) {
      this.paymentForm.removeControl('promoCode');
      this.promoFormControl.updateValueAndValidity();
    } else {
      this.paymentForm.addControl('promoCode', this.promoFormControl);
      this.promoFormControl.updateValueAndValidity();
    }
  }

  getPromoDescription(promo: Promotion): string {
    if (this.currentProduct.type === 'Gas' || this.currentProduct.type === 'Luce') return promo.descriptionMono;
    if (this.currentProduct.type === 'Luce & Gas') return promo.descriptionBi;
  }

  openPromoBox() {
    this.isPromoBoxOpen = !this.isPromoBoxOpen;
    this.gtm.submitOnbEvent('click su dropdown codice promozionale', '');
    if (this.isPromoBoxOpen) {
      this.currentOnboarding.promoCode = null;
      if (<HTMLInputElement>document.getElementById('input-promoCode')) {
        (<HTMLInputElement>document.getElementById('input-promoCode')).value = null;
      }
    } else {
      this.currentOnboarding.friendCode = null;
      this.currentOnboarding.promoCode = null;
      this.paymentForm.removeControl('promoCode');
      this.greenEnergyEnabledWithPromo = false;
      this.disableGreenPromo();
    }
    this.currentOnboarding.isPromoSelected = !this.currentOnboarding.isPromoSelected;
  }

  changeStatus(value) {
    this.gtm.submitOnbEvent('clic su indietro', 'payment');
    this.statusBack.emit(value);
    if (!this.resetLibrettoValidations || !this.goToNextStep) {
      this.api.isLibrettoInputDisabled$.next(false);
      this.api.isLibrettoValid$.next(undefined);
    }
  }

  verifyBooklet() {
    if (!this.isLibrettoControlled) return;
    if (this.isLibrettoValid && this.librettoInputDisabled) return;
    this.api
      .checkBookletValidity(this.currentOnboarding.cf, this.currentOnboarding.librettoCode)
      .toPromise()
      .then((data) => {
        const result = data.data;
        if (result.status) {
          this.gtm.submitLibrettoCodeEvent('ok');
          this.api.isLibrettoValid$.next(true);
          this.api.isLibrettoInputDisabled$.next(true);
          this.api.isLibrettoCodeConfirmed$.next(true);
        } else {
          this.api.isLibrettoValid$.next(false);
          this.api.isLibrettoInputDisabled$.next(false);
          this.gtm.submitLibrettoCodeEvent('Libretto non esistente o non associato al codice fiscale');
          this.isLibrettoValid = false;
        }
      })
      .catch((err) => {
        this.api.isLibrettoInputDisabled$.next(false);
        this.api.isLibrettoValid$.next(false);
        this.gtm.submitLibrettoCodeEvent('Libretto non esistente o non associato al codice fiscale');
        this.isLibrettoValid = false;
      });
  }

  verifyLibrettoCode(checkLibrettoCode: any) {
    this.currentOnboarding.librettoCode = checkLibrettoCode;
    if (checkLibrettoCode.length === 13) {
      this.isLibrettoControlled = true;
    } else {
      this.isLibrettoValid === undefined;
      this.isLibrettoControlled = false;
      this.api.isLibrettoInputDisabled$.next(false);
      this.api.isLibrettoValid$.next(undefined);
    }
  }

  verifyLibrettoCodeLength(status: any) {
    if (this.currentOnboarding.librettoCode.length === 13) {
      status.target.disabled = true;
    }
    status.target.disabled = false;
  }

  resetLibrettoInput(status: any) {
    if (status.target.value.length === 13 && !this.goToNextStep && this.isLibrettoValid === undefined) {
      status.target.value = null;
      this.goToNextStep = false;
      this.resetLibrettoValidations = false;
    }
  }

  checkLength(event) {
    if (event.target.value.toString().length >= this.maxLength) {
      event.target.value.split(0, -1);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/steps/alg-payment/alg-payment.component.ts